import { FC, ReactNode } from 'react';

import { Box, Card, Grid, PageGrid, Stack, Stretch } from '@eneco/sparky';

interface CenteredCardLayoutProps {
  children: ReactNode;
}

/**
 * A centered card layout component that wraps content in a responsive card
 * centered on the page with consistent padding and styling.
 */
const CenteredCardLayout: FC<CenteredCardLayoutProps> = ({ children }) => {
  return (
    <Stretch>
      <Stack alignY={'center'}>
        <Box padding="8">
          <PageGrid>
            <Grid.Item gridColumn={{ initial: '1/-1', md: '3 / span 8', lg: '5 / span 4' }}>
              <Card as="div" corners="rounded" elevation="S" overflow="hidden">
                <Box padding="10">
                  <Stack gap="6">{children}</Stack>
                </Box>
              </Card>
            </Grid.Item>
          </PageGrid>
        </Box>
      </Stack>
    </Stretch>
  );
};

export default CenteredCardLayout;
